export default {
  sm: `
  내일을 설계하는 데이터센터
  `,
};
